<template>
  <v-card class="position-relative item" :to="item.to" flat tile>
    <img :src="files + item.img" class="d-block item-img" width="100%" />

    <v-sheet
      color="transparent"
      v-if="item.title"
      height="115px"
      width="100%"
      class="d-flex align-end overflow-hidden item-caption"
    >
      <v-sheet
        color="primary"
        height="75px"
        width="100%"
        class="
          d-flex
          align-center
          justify-center
          px-3 px-md-5
          position-relative
          item-caption-slop
        "
      >
        <div
          class="
            white--text
            text-body-2 text-md-h6 text-center
            font-weight-bold
            item-title
          "
        >
          <span class="font-secondary">
            {{ item.title }}
          </span>
        </div>
      </v-sheet>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 264 / 348;
    object-fit: cover;
    -o-object-fit: cover;
  }

  &-caption {
    bottom: 0;
    position: absolute;

    &-slop {
      &:before,
      &:after {
        content: "";
        border-style: solid;
        height: 0px;
        left: -96px;
        position: absolute;
        width: 0px;
      }

      &:before {
        border-color: transparent var(--v-secondary-base) transparent
          transparent;
        border-width: 40px 275px 0 96px;
        top: -40px;

        @media screen and (max-width: 1199px) {
          border-width: 40px 201px 0 96px;
        }

        @media screen and (max-width: 960px) {
          border-width: 40px 50vw 0 96px;
        }
      }

      &:after {
        border-color: transparent var(--v-primary-base) transparent transparent;
        border-width: 30px 275px 0 96px;
        top: -30px;

        @media screen and (max-width: 1199px) {
          border-width: 30px 201px 0 96px;
        }

        @media screen and (max-width: 960px) {
          border-width: 30px 50vw 0 96px;
        }
      }
    }
  }

  &-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
